import { Typography } from '@mui/material'
import { WorkflowStateAction } from '@/types/workflow-state-actions'

type MoveCleanDocumentsDisplayProps = {
  action: WorkflowStateAction
}

export default function MoveToNextStateDisplay({
  action,
}: MoveCleanDocumentsDisplayProps) {
  const defaultDescription = action.action_type?.description.slice(0, -1) // remove period
  const checkIfClean = action.params.check_if_clean
  return (
    <Typography variant="body2" color="text.secondary">
      {defaultDescription}
      {checkIfClean ? ', if the document has no flags' : ''}.
    </Typography>
  )
}
